import { render } from "./Sensor.vue?vue&type=template&id=cae39d88"
import script from "./Sensor.vue?vue&type=script&lang=js"
export * from "./Sensor.vue?vue&type=script&lang=js"
script.render = render

export default script